import { useFetchCurrencyRates } from '~/modules/analytics';

export const useShopifyCurrencyConverter = () => {
  const { currencyRates } = useFetchCurrencyRates();

  const convertAmount = (amount: number, from: string, to: string) => {
    if (!currencyRates) return amount;
    if (from === to) return amount;

    if (currencyRates[from] && currencyRates[to]) {
      const convertedAmount = (amount * currencyRates[from]) / currencyRates[to];
      return convertedAmount ? Number(convertedAmount.toFixed(2)) : amount;
    }
    return amount; // Fallback if rates are missing
  };

  return {
    convertAmount,
  };
};
